// extracted by mini-css-extract-plugin
var _1 = "GqEGI6MG6673YtkOGJYp";
var _2 = "PTuYkrtQPxRg5UHfU6cQ";
var _3 = "jl5EvdzT8onpjzbESL9M";
var _4 = "ASYvXUPbHOx307hvnvQ_";
var _5 = "IZfPiwxT22e3PAXr0UyU";
var _6 = "_3Y2tsMzlvx8a2_V9GaA9";
export { _1 as "colEmail", _2 as "colFirstName", _3 as "colLastName", _4 as "colLastUpdated", _5 as "colOrganization", _6 as "colStatus" }
